import DraggableItem from 'javascripts/dnd/DraggableItem';
import { type UiItem } from '../controllers/types';

class DraggableUiItem extends DraggableItem<UiItem> {}

export default DraggableUiItem;
